import styled from 'styled-components';
import { DeleteIcon } from '../../../assets/icons/DeleteIcon';
import Button from '../../../components/button/Button';
import { Table, TableHead, TableRow, TableBody, TableCell } from '../../../components/table/Table';
import StatusIndicator, { STATUS } from '../../../components/status-indicator/StatusIndicator';
import QuantityCell from './QuantityCell';
import TextField from '../../../components/text-field/TextField';
import { useMemo, useState } from 'react';
import { ItemCountingLineDTO } from '../../../api/api';
interface Props {
  goods: ItemCountingLineDTO[];
  updateGoodQuantity: (itemId?: string, quantity?: number, checked?: boolean) => void;
  reset: () => void;
}

const CountGoodsList = (props: Props) => {
  const { goods, updateGoodQuantity, reset } = props;

  const [searchText, setSearchText] = useState('');

  const filteredGoods = useMemo(() => {
    return [...goods]
      .filter(
        (g) =>
          g.itemName?.toLocaleLowerCase()?.includes(searchText.toLocaleLowerCase()) ||
          g.itemId?.includes(searchText.toLocaleLowerCase())
      )
      .sort((a, b) => {
        if (a.checked !== b.checked) {
          return a.checked ? 1 : -1;
        }
        return (a.itemName?.toLocaleLowerCase() ?? '').localeCompare(b.itemName?.toLocaleLowerCase() ?? '');
      });
  }, [goods, searchText]);

  return (
    <>
      <Header>
        <TextField compact value={searchText} onChange={(e) => setSearchText(e.target.value)} label="Søg blandt varer" />
        <Row>
          <Button variant="secondary" onClick={reset}>
            <DeleteIcon /> Nulstil optælling
          </Button>
        </Row>
      </Header>

      <StyledTableContainer>
        <Table cellSpacing={'1px'}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Varenummer</TableCell>
              <TableCell>Varenavn</TableCell>
              <TableCell>Antal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredGoods.map((good) => (
              <TableRow key={good.itemId}>
                <TableCell>
                  {good.checked !== undefined && (
                    <StatusIndicator
                      interactive
                      status={good.checked ? STATUS.GREEN : STATUS.GREY}
                      onClick={() => updateGoodQuantity(good.itemId, good.quantity, !good.checked)}
                    />
                  )}
                </TableCell>
                <TableCell>{good.itemId}</TableCell>
                <TableCell>{good.itemName}</TableCell>
                <TableCell>
                  <QuantityCell
                    row={{ goodsId: good.itemId }}
                    minValue={0}
                    qty={good.quantity?.toString()}
                    setGoodsAmount={(val, id) => updateGoodQuantity(id, val, good.checked)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${(props) => props.theme.spacing(1)};
  margin-bottom: ${(props) => props.theme.spacing(4)};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${(props) => props.theme.spacing(3)};
  height: 50px;
`;

const StyledTableContainer = styled.div`
  height: 90%;
  overflow-y: scroll;
`;

export default CountGoodsList;
